<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'stats_user_infos.heures_travaillees' | trans" [widget]="widget()" [filter]="true" [editable]="editable()">
    <ng-content/>
    <vl-widget-period-filters class="filter" [(period)]="period" [(timeScale)]="timeScale" [(comparison)]="comparison"/>
  </vl-widget-title>

  @if (stats() === null) {
    <vl-loader-skeleton [count]="3" [height]="40"/>
  } @else if (chartData().labels.length) {
    <div class="chart-area fade-in">
      <canvas #heuresChart></canvas>
    </div>
    <div class="flex-row justify-center p-8">
      <span class="caption on-background-alt">{{ 'stats_user_infos.total' | trans }} : {{ totalHeures() }}h</span>
    </div>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
</div>
